'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of hypothyroidism
 */ const Hypothyroidism = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3477_3619)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M54.7427 18.668C41.8898 18.668 31.3582 28.5565 30.3468 41.1275L25.1284 50.9739C24.6403 51.8961 24.9985 53.0357 25.9291 53.5161L30.259 55.7428V58.9723H48.4708C53.331 58.9723 57.3449 62.6437 57.8787 67.3565C57.9173 67.7107 57.9419 68.0683 57.9419 68.4295V80.3238L65.8327 77.4028C66.9003 77.0066 67.6097 75.9861 67.6097 74.85V63.9096C74.5769 59.6 79.2229 51.8996 79.2229 43.1122C79.2264 29.6119 68.2628 18.668 54.7427 18.668Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M48.5117 64.6543C48.5117 64.6543 48.4836 64.6543 48.4696 64.6543H30.2578V67.691C30.2578 68.7359 31.1076 69.5845 32.1541 69.5845H42.8579V84.021C42.8579 84.9397 43.7744 85.5744 44.6348 85.2553L52.2552 82.4361V68.4344C52.2552 68.0837 52.2026 67.7471 52.1148 67.4245C51.6758 65.843 50.2325 64.6753 48.5152 64.6578L48.5117 64.6543Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M69.3992 45.1955C68.6161 46.2966 67.6118 47.296 66.3757 48.2357C63.043 49.8663 60.8482 46.0231 60.8482 46.0231L63.8261 53.7831C63.9069 53.997 63.8999 54.239 63.8016 54.4493C63.7032 54.6562 63.5276 54.807 63.3169 54.8631L62.8077 54.9999C62.2388 55.1507 61.6454 54.8771 61.3574 54.3266L58.0459 47.9622C56.1285 47.3486 55.1733 45.8057 54.8221 43.8876C54.8151 43.856 54.808 43.821 54.801 43.7894C54.7905 43.8245 54.7729 43.856 54.7624 43.8876C53.7932 46.4334 49.0804 46.4018 47.5599 43.8876C47.2052 43.302 47.0226 42.5762 47.1068 41.7206C47.0893 41.7206 47.0682 41.71 47.0542 41.7206C41.9832 45.0553 37.1616 37.8668 41.3862 31.541C44.2343 27.277 49.7125 24.293 55.707 24.293C64.395 24.293 71.436 30.5802 71.436 38.3332C71.436 41.0543 70.7548 43.2704 69.3957 45.1885L69.3992 45.1955Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3477_3619",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "54.3158",
                        height: "66.6666",
                        fill: "white",
                        transform: "translate(24.9062 18.6641)"
                    })
                })
            })
        ]
    });
};

exports.Hypothyroidism = Hypothyroidism;
//# sourceMappingURL=Hypothyroidism.cjs.map
